import SyncWorklogsModal from './SyncWorklogsModal';

export default SyncWorklogsModal;
